import { Component, createApp, Plugin } from 'vue';
import { Router } from 'vue-router';
import { attachSentryToApp } from '../../Plugins/sentry';

export type ComponentLoadingParams = {
    plugins: Array<Plugin | [Plugin, Record<string, any>]>;
    component: () => Promise<{default: Component}>;
    router?: () => Router;
}

export const mountComponents = async (components: Record<string, ComponentLoadingParams>) => {
    for (const [name, {plugins, component, router}] of Object.entries(components)) {
        const mountPoints = document.querySelectorAll(`[data-component="${name}"]`);

        mountPoints.forEach(async mountPoint => {
            const props = mountPoint.getAttribute('data-props');
            const { default: Component } = await component();
            const app = createApp(Component, (props) ? JSON.parse(props) : {});

            plugins.forEach(plugin => {
                if (Array.isArray(plugin)) {
                    return app.use(...plugin);
                }
                app.use(plugin);
            });
            if (router) {
                app.use(router());
            }
            attachSentryToApp(app);
            app.mount(mountPoint);
        });
    }
};
